// function plyrVideoInit() {
//     const videoPlayer3rdParty = Plyr.setup('.video-plyr .video-inner', {
//         controls: [], // Hide Plyr's controls
//         autoplay: true,
//         muted: true,
//         loop: {
//             active: true
//         },
//         vimeo: {
//             byline: false,
//             transparent: true,
//             controls: false,
//             responsive: true,
//             muted: true,
//         }
//     });
//
//
// }
//
// document.addEventListener("DOMContentLoaded", function () {
//     if (document.querySelector('.video-plyr')) {
//         plyrVideoInit();
//     }
// });








function handleHeroVimeo() {
    const el = document.querySelector('.background-video.vimeo');
    if (!el) return;
    let film = false;
    const filmId = el.dataset.vimeo;
    // console.log('vimeo loading: ' + filmId);

    if (filmId) {
        film = new Vimeo.Player(el, {
            id: filmId,
            background: true,
        });
    }
}

function plyrVideoInit() {
    if (document.querySelector('.video-plyr .video-inner video')) { // if HTML5 video
        const videoPlayerFile = Plyr.setup('.video-plyr .video-inner video', {
            // controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen']
            controls: [],
            autoplay: true,
            muted: true,
            loop: {
                active: true
            },

        });
    }
    // } else { // Youtube or Vimeo
    //     const videoPlayer3rdParty = new Plyr('.video-plyr .video-inner', {
    const videoPlayer3rdParty = Plyr.setup('.video-plyr .video-inner', {
        // volume: 0.1,
        controls: [],
        autoplay: false,
        muted: true,
        loop: {
            active: true
        },

        vimeo: {
            byline: false,
            // speed: true,
            transparent: true,
            controls: false,
            responsive: true,

        }


    });

    //force each video to play after 1 second if not already playing via a foreach loop
    // setTimeout(function () {
    //     videoPlayer3rdParty.forEach(function (instance) {
    //
    //         // Show loading animation.
    //         let playPromise = instance.play();
    //
    //         if (playPromise !== undefined) {
    //             playPromise.then(_ => {
    //                 console.log('video playing from promise');
    //                 instance.play();
    //             })
    //                 .catch(error => {
    //                     console.log('video already playing (promise)');
    //                 });
    //         }
    //
    //
    //
    //     });
    // }, 1500);

    if (document.querySelector('body.home')) {

        //check if width is less than 768px
        if (window.innerWidth < 768) {
            videoPlayer3rdParty[1].on('ready', (event) => {
                const instance = event.detail.plyr;
                instance.play();
            });
        } else {
            videoPlayer3rdParty[0].on('ready', (event) => {
                const instance = event.detail.plyr;
                instance.play();
            });
        }
    }



    // //play video when scrolled into view
    // const options = {
    //     root: null,
    //     rootMargin: '0px',
    //     threshold: 0.5
    // };
    //
    // const callback = (entries, observer) => {
    //     entries.forEach(entry => {
    //         if (entry.isIntersecting) {
    //             console.log('video is intersecting');
    //             // console.log('entry.target: ', entry.target);
    //             // console.log('entry.target.querySelector: ', entry.target.querySelector('.plyr__video-wrapper'));
    //
    //             const video = entry.target.querySelector('.plyr__video-wrapper');
    //             const videoId = video.dataset.plyrProvider;
    //             // console.log('videoId: ', videoId);
    //         }
    //         ;
    //     });
    // };
    //
    // const observer = new IntersectionObserver(callback, options);
    // const targets = document.querySelectorAll('.video-plyr .video-inner');
    // targets.forEach(target => {
    //     observer.observe(target);
    //     console.log('target: ', target);
    // });

} // end plyrVideoInit

document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector('.video-plyr')) {
        plyrVideoInit();
    }
    handleHeroVimeo();
});